import Pageable from "@/entities/pageable/pageable_collection";
import { ServicePoint, ServicepointType } from "@/entities";
import { ResponseCreate, ResponseCreateV2 } from "@/services";
import { DeviceV2 } from "@/entities/device";

export interface ServicePointService {
  fetchServicePoints(map: Record<string, unknown>): Promise<Pageable<ServicePoint>>;
  fetchServicePointsByGroupRules(groupId: string, map: Record<string, unknown>): Promise<Pageable<ServicePoint>>;
  createServicePointV3(servicePoint: ServicePoint): Promise<ResponseCreateV2>;
  updateServicePointV3(servicePoint: ServicePoint): Promise<void>;
  changeStatus(servicePoint: ServicePoint): Promise<void>;
  fetchServicePointTypes(): Promise<ServicepointType[]>;
}

export interface IServicePointFilter {
  text?: string;
  countryCode?: string;
  entityCode?: string;
}

export interface IServicePointPageFilter {
  code?: string;
  name?: string;
  refresh: boolean;
  active: boolean;
}

export const iniServicePointPageFilter: IServicePointPageFilter = {
  code: "",
  name: "",
  refresh: false,
  active: true,
};

export const iniServicePointFilter: IServicePointFilter = {
  text: "",
  countryCode: "",
  entityCode: "",
};

export interface IRequestServicePointFilter {
  servicePointName?: string;
  servicePointCode?: string;
  countryCode?: string;
  entityCode?: string;
  deviceCode?: string;
  centerId?: string;
  active?: boolean;
}

export const iniRequestServicePointFilter: IRequestServicePointFilter = {
  servicePointName: "",
  countryCode: "",
  entityCode: "",
  deviceCode: "",
};

export interface ServicePointServiceMock {
  fetchServicePoints: jest.Mock<Promise<Pageable<ServicePoint>>>;
  fetchServicePointsByGroupRules: jest.Mock<Promise<Pageable<ServicePoint>>>;
  createServicePointV3: jest.Mock<Promise<ResponseCreateV2>>;
  updateServicePointV3: jest.Mock<Promise<void>>;
  changeStatus: jest.Mock<Promise<void>>;
  fetchServicePointTypes: jest.Mock<Promise<ServicepointType[]>>;
}
